import React from 'react'
import useLiverForeverPreviewHook from './useLiverForeverPreview.hook'
import DocumentScanningGif from '../../../../assets/animations/document-scanning.gif'
import Layout from '../../../../components/Layout'
import CloseIcon from '../../../../components/Icons/CloseIcon'
import Text from '../../../../components/Text'
import DocumentView from '../../../../components/care-plans/DocumentView'
import AddressCard from '../../../../components/AddressSelector/AddressCard'
import { useLocation, useNavigate } from 'react-router-dom'
import Button from '../../../../components/ButtonNew'
import { getUrlParams } from '../../../../utils/helpers/common'
import ArrowLeftIcon from '../../../../components/Icons/ArrowLeft'
import Spinner from '../../../../components/Spinner'
import { supportProgramStatus } from '../../../../constants/support-programs'

const getDocumentStatus = (status) => {
  return status === supportProgramStatus.DOCUMENT_REVIEW_STATUS.REJECTED
    ? 'rejected'
    : status === supportProgramStatus.DOCUMENT_REVIEW_STATUS.UNDER_REVIEW
      ? 'under_review'
      : 'pending'
}
const LiverForeverPreviewPage = () => {
  const params = getUrlParams()
  const {
    supportProgram,
    uploadDocumentData,
    documents,
    handleBackToCareProgramClick,
    onUploadSuccess,
  } = useLiverForeverPreviewHook()

  const address = useLocation().state?.address
  const navigate = useNavigate()
  console.log('address', address)

  const handleBackButtonClick = () => {
    navigate('/care-plans/liver-forever-program')
  }

  return (
    <Layout className="bg-white">
      <div className="min-w-sm max-w-lg relative mx-auto w-full h-screen bg-[#F2F4F7] overflow-y-auto">
        {params?.first_time ? (
          <>
            <div className="h-[56px] flex items-center justify-end px-4 bg-[#EEF4FF]">
              <button
                className="p-1 bg-gray-400 rounded-full"
                onClick={handleBackToCareProgramClick}
              >
                <CloseIcon color="#fff" width={16} height={16} />
              </button>
            </div>
            <div className="flex flex-col items-center bg-[#EEF4FF] px-4 py-6">
              <div>
                <img
                  src={DocumentScanningGif}
                  className="w-[150px] h-[150px]"
                  alt="document-scanning"
                />
              </div>
              <div className="flex flex-col items-center gap-2">
                <Text
                  variant="title"
                  size="large"
                  tag="p"
                  className="font-bold !text-center"
                >
                  Documents Uploaded Successfully
                </Text>
                <Text
                  variant="body"
                  size="medium"
                  tag="p"
                  className="font-bold !text-center"
                >
                  Your documents are currently under review.{' '}
                  <b>Liver Forever Program</b> will be assigned to you after
                  your documents are approved
                </Text>
              </div>
            </div>
          </>
        ) : (
          <div className="pb-12">
            <div className="z-10 fixed top-0 left-0 right-0 border-b border-gray-200 bg-white px-4 py-3 flex flex-col gap-3">
              <div className="flex items-center gap-2">
                <button onClick={handleBackButtonClick}>
                  <ArrowLeftIcon />
                </button>
                <Text
                  variant="body"
                  size="large"
                  tag="label"
                  className="font-bold"
                >
                  {supportProgram?.name}
                </Text>
              </div>
            </div>
          </div>
        )}

        {documents?.loading ? (
          <div className="flex justify-center items-center h-full">
            <Spinner />
          </div>
        ) : (
          <div className="px-4 py-6 gap-4 flex flex-col pb-[98px]">
            {uploadDocumentData?.document_types.map((documentTypes) => {
              const document =
                documents?.data?.data?.find(
                  (i) => i.title === documentTypes.document_title,
                ) ?? null

              const documentStatus =
                document?.record_meta_info?.report_status ===
                supportProgramStatus.DOCUMENT_REVIEW_STATUS.REJECTED
                  ? 'rejected'
                  : document?.record_meta_info?.report_status ===
                      supportProgramStatus.DOCUMENT_REVIEW_STATUS.UNDER_REVIEW
                    ? 'under_review'
                    : document?.record_meta_info?.report_status ===
                        supportProgramStatus.DOCUMENT_REVIEW_STATUS.APPROVED
                      ? 'approved'
                      : 'pending'

              return (
                <DocumentView
                  document={document}
                  documentType={documentTypes.document_type}
                  drugName={supportProgram?.drug_name}
                  uploadReportType={uploadDocumentData?.upload_report_type}
                  documentStatus={documentStatus}
                  onUploadSuccess={onUploadSuccess}
                  // afterCompletion={() => onUploadSuccess('prescription')}
                  // setIsLoaderVisible={setLoader}
                  // onDeletePress={() => onDeletePress('prescription')}
                />
              )
            })}

            {/* <AddressCard
            address={address}
            isEditable={true}
            onEditClick={() => console.log('edit')}
          /> */}
          </div>
        )}

        <div className="px-4 py-2 bg-white fixed bottom-0 left-0 right-0 border-t border-gray-200">
          <Button
            fullWidth
            onClick={handleBackToCareProgramClick}
            // onClick={handleProceedClick}
            // disabled={!purchaseInvoice || !prescription}
          >
            {params?.first_time ? 'Back To Care Program' : 'Proceed'}
          </Button>
        </div>
      </div>
    </Layout>
  )
}

export default LiverForeverPreviewPage
